import {NavLink} from "react-router-dom";
import {API_URL} from "../../../../api/RequestConstants";

import ImgWithFallback from "../../ImgWithFallback";

import banner1 from '../../../../assets/img/news/banners/news1.png';
import './NewsCard.sass';

const NewsCard = ({banner, author, title, date, hashtags, slug}) => {
    return (
        <article className='news-card'>
            <NavLink to={'/newsroom/' + slug}>
                <div className='news-card-banner'>
                    <ImgWithFallback
                        src={API_URL + '/' + banner.path}
                        fallbackSrc={banner1}
                        alt={banner.meta_alt}
                        title={banner.meta_title}
                        width={550}
                        height={490}
                    />
                </div>
                <div className='news-card-content'>
                    <p className='news-card-author'>{author}</p>
                    <h3 className='news-card-title'>{title}</h3>
                    <p className='news-card-small'>{date}</p>
                    <p className='news-card-small'>{hashtags}</p>
                </div>
            </NavLink>
        </article>
    );
};

export default NewsCard;